import {SET_AUTHORS} from 'constants/actionTypes';

export const setAuthors = payload => ({type: SET_AUTHORS, payload});
